/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface TopOfBookSource {
  id?: number;
  type?: TopOfBookSource.TypeEnum;
  pairId?: number;
  pair?: Pair;
  name?: string;
  enabled?: boolean;
  source1?: number;
  weight1?: number;
  source2?: number;
  weight2?: number;
  source3?: number;
  weight3?: number;
  source4?: number;
  weight4?: number;
}
export namespace TopOfBookSource {
  export const TypeEnum = {
    BinanceSpot: 'BINANCE_SPOT',
    BinancePerpetual: 'BINANCE_PERPETUAL',
    BybitSpot: 'BYBIT_SPOT',
    BybitPerpetual: 'BYBIT_PERPETUAL',
    OkxSpot: 'OKX_SPOT',
    OkxPerpetual: 'OKX_PERPETUAL',
    Aggregate: 'AGGREGATE',
    Multiply: 'MULTIPLY',
    Divide: 'DIVIDE',
    PerpSpotChaining: 'PERP_SPOT_CHAINING',
    LiquidityProvider: 'LIQUIDITY_PROVIDER',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    KrakenSpot: 'KRAKEN_SPOT',
    CoinbaseSpot: 'COINBASE_SPOT',
  } as const;
  export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
